import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/auth.service';
import Storage from '../../services/Storage';


export const login = createAsyncThunk(
    "auth/login",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.login(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            console.log(error.response.status)
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)

export const loginFrn = createAsyncThunk(
    "auth/login-frn",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.loginFrn(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            console.log(error.response.status)
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)

export const loginForConf = createAsyncThunk(
    "auth/loginForConf",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.loginForConf(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            console.log(error.response.status)
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)

export const checkConfig = createAsyncThunk(
    "auth/checkConfig",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.checkConfig(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)

export const configure = createAsyncThunk(
    "auth/configure",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.configure(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)

export const checkAuth = createAsyncThunk(
    "auth/check",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.checkUser(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)

export const getMyClaims = createAsyncThunk(
    "auth/getMyClaims",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getMyClaims(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            const status = (error.response && error.response.status) || null
            return rejectWithValue({ message, status })
        }
    }
)



const initialState = {
    loading: false,
    error: '',
    loggedUser: null,
    error_code: null,
    //auth magasin configuration
    mgToken:null
}

const AuthSlice = createSlice({
    name: "Auth",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        loadLoggedUser: (state) => {
            state.loggedUser = Storage.getData()
        },
        loadMgToken: (state) => {
            state.mgToken = Storage.getMgToken()
        },
        logout: (state) => {
            Storage.logout()
            Object.assign(state, initialState)
        },
        clearConfig: (state) => {
            Storage.clearConfig()
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder

            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = '';
                state.loggedUser = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.error = '';
                if (action.payload?.access_token)
                    Storage.setToken(action.payload?.access_token)
                if (action.payload?.user) {
                    state.loggedUser = action.payload?.user;
                    Storage.setData(action.payload?.user)
                }
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message;
                state.error_code = action.payload?.status;
                state.loggedUser = null;
            })




            .addCase(loginFrn.pending, (state) => {
                state.loading = true;
                state.error = '';
                state.loggedUser = null;
            })
            .addCase(loginFrn.fulfilled, (state, action) => {
                state.loading = false;
                state.error = '';
                if (action.payload?.access_token)
                    Storage.setToken(action.payload?.access_token)
                if (action.payload?.user) {
                    state.loggedUser = action.payload?.user;
                    Storage.setData(action.payload?.user)
                }
            })
            .addCase(loginFrn.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message;
                state.error_code = action.payload?.status;
                state.loggedUser = null;
            })



            .addCase(configure.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(configure.fulfilled, (state, action) => {
                state.loading = false;
                state.error = '';
                if (action.payload)
                    Storage.setMgToken(action.payload)
                
            })
            .addCase(configure.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message;
                state.error_code = action.payload?.status;
            })



            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload?.message
                state.error_code = action.payload?.status;
            })



    }
})

const { reducer } = AuthSlice;
export const { clear, loadLoggedUser, logout, loadMgToken, clearConfig } = AuthSlice.actions;
export default reducer;